type MediaQueryChangeEventListener = (event: MediaQueryListEvent) => unknown;

export const mediaQuerySupportsEventTargetMethods =
  Object.getPrototypeOf(typeof window !== 'undefined' && window.matchMedia('')) instanceof
  EventTarget;

/**
 * Appends a `change` event listener to a `MediaQueryList` instance.
 * - Delegates to `addEventListener` in modern browsers.
 * - Delegates to `addListener` in Safari < 14.
 */
export const addMediaQueryListener = mediaQuerySupportsEventTargetMethods
  ? (
      mediaQuery: MediaQueryList,
      listener: MediaQueryChangeEventListener,
      options?: boolean | AddEventListenerOptions
    ) => mediaQuery.addEventListener('change', listener, options)
  : (mediaQuery: MediaQueryList, listener: MediaQueryChangeEventListener) =>
      mediaQuery.addListener(listener);

/**
 * Removes a `change` event listener from a `MediaQueryList` instance.
 * - Delegates to `removeEventListener` in modern browsers.
 * - Delegates to `removeListener` in Safari < 14.
 */
export const removeMediaQueryListener = mediaQuerySupportsEventTargetMethods
  ? (
      mediaQuery: MediaQueryList,
      listener: MediaQueryChangeEventListener,
      options?: boolean | EventListenerOptions
    ) => mediaQuery.removeEventListener('change', listener, options)
  : (mediaQuery: MediaQueryList, listener: MediaQueryChangeEventListener) =>
      mediaQuery.removeListener(listener);
